export default __webpack_public_path__ + "static/media/user-plus.f411bfb1.svg";